import { Colors, regExp } from '@sigma-frontend-libs/commons'
import { BILLING_CURRENCY } from '@sigma-legacy-libs/essentials/lib/constants'
import { CSendingTypesGenerallyAvailable } from '@sigmasms/commons'

import { buttonModes, components, icons, labelModes, permissionPresets, services } from '@/utils'

import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import arrow from '@/components/misc/arrow'
import RowWithMessageTypeIcon from '@/components/misc/RowWithMessageTypeIcon'
import selectorSendingType from '@/components/selector/sendingType'
import tag from '@/components/tag'

function renderHeaderContent(h, options) {
  const { path, serviceName } = options

  return h(
    'div',
    {
      class: 'faic grid-gap--8'
    },
    [
      h(
        squircle,
        {
          props: {
            icon: icons.integration_instructions,
            color: Colors.grey
          }
        }
      ),
      this.getTranslate(`${serviceName}.subtitles.${path}`)
    ]
  )
}
function renderHeader(h, options, expanded) {
  return h(
    'div',
    {
      class: 'default-expansion-panel-header pl-2'
    },
    [
      renderHeaderContent.call(this, h, options),
      h(arrow, { props: { expanded } })
    ]
  )
}

function renderAllowDuplicatesField(h, { path, serviceName }) {
  return h(
    components.switch,
    {
      props: {
        value: this.proxy.allowDuplicates,
        label: this.getTranslate(`${serviceName}.labels.${path}.allowDuplicates`),
        outline: true
      },
      on: {
        input: event => {
          this.proxy.allowDuplicates = event
        }
      }
    }
  )
}
function renderSenderNamesCheckField(h, { path, serviceName }) {
  return h(
    selectorSendingType,
    {
      props: {
        value: this.proxy.sendernamesCheck,
        label: this.getTranslate(`${serviceName}.labels.${path}.sendernamesCheck`),
        items: CSendingTypesGenerallyAvailable,
        multiple: true,
        labelMode: labelModes.outline,
        cancelable: true
      },
      on: {
        input: event => {
          this.proxy.sendernamesCheck = event
        }
      }
    }
  )
}
function renderPatternsCheckField(h, { path, serviceName }) {
  if (this.checkPermissions(`advanced.${services.patterns}.get`, permissionPresets.resellerUp)) {
    return h(
      selectorSendingType,
      {
        props: {
          value: this.proxy.patternsCheck,
          label: this.getTranslate(`${serviceName}.labels.${path}.patternsCheck`),
          items: CSendingTypesGenerallyAvailable,
          multiple: true,
          labelMode: labelModes.outline,
          cancelable: true
        },
        on: {
          input: event => {
            this.proxy.patternsCheck = event
          }
        }
      }
    )
  }
}
function renderBalanceField(h, { path, serviceName }) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.balance,
        label: this.getTranslate(`${serviceName}.labels.${path}.balance`),
        labelMode: labelModes.outline,
        dense: true,
        clearable: true,
        details: false,
        mask: regExp.positiveNumberTwoSymbolsAfterDot
      },
      on: {
        input: event => {
          this.proxy.balance = event
        }
      }
    }
  )
}
function renderCurrencyField(h, { path, serviceName }) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.currency,
        label: this.getTranslate(`${serviceName}.labels.${path}.currency`),
        items: BILLING_CURRENCY.map(item => {
          return {
            value: item,
            title: this.getTranslate(`${services.billings}.currency.${item}`)
          }
        }),
        labelMode: labelModes.outline,
        dense: true,
        required: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.currency = event
        }
      }
    }
  )
}
function renderSelectTariffsField(h, { path, serviceName }) {
  if (this.checkPermissions(`advanced.${services.tariffs}.get`, permissionPresets.resellerUp)) {
    return h(
      components.select,
      {
        props: {
          value: this.proxy.tariffs,
          label: this.getTranslate(`${serviceName}.labels.${path}.${services.tariffs}`),
          service: services.tariffs,
          labelMode: labelModes.outline,
          picks: [ 'id', 'title', 'source' ],
          dense: true,
          multiple: true,
          autocomplete: true,
          clearable: true,
          details: false
        },
        on: {
          input: event => {
            this.proxy.tariffs = event
          }
        },
        scopedSlots: {
          selection: ({ item, removeByValue }) => {
            const [ source, type ] = item.source && item.source.split('.') || []

            return h(
              RowWithMessageTypeIcon,
              {
                props: {
                  value: type || source,
                  title: item.title,
                  cancelable: true,
                  cancel: () => {
                    return removeByValue(item)
                  }
                }
              }
            )
          },
          item: ({ item }) => {
            const [ source, type ] = item.source && item.source.split('.') || []

            return h(
              RowWithMessageTypeIcon,
              {
                props: {
                  value: type || source,
                  title: item.title,
                  as: 'text'
                }
              }
            )
          }
        }
      }
    )
  }
}
function renderSelectRoutingGroupsField(h, { path, serviceName }) {
  if (this.checkPermissions(`advanced.${services.routingGroups}.get`, permissionPresets.resellerUp)) {
    return h(
      components.select,
      {
        props: {
          value: this.proxy.routingGroups,
          label: this.getTranslate(`${serviceName}.labels.${path}.${services.routingGroups}`),
          service: services.routingGroups,
          picks: [ 'id', 'title', 'type' ],
          multiple: true,
          autocomplete: true,
          labelMode: labelModes.outline,
          dense: true,
          clearable: true,
          details: false
        },
        on: {
          input: event => {
            this.proxy.routingGroups = event
          }
        },
        scopedSlots: {
          selection: ({ item, removeByValue }) => {
            return h(
              RowWithMessageTypeIcon,
              {
                props: {
                  value: item.type,
                  title: item.title,
                  cancelable: true,
                  cancel: () => {
                    return removeByValue(item)
                  }
                }
              }
            )
          },
          item: ({ item }) => {
            return h(
              RowWithMessageTypeIcon,
              {
                props: {
                  value: item.type,
                  title: item.title,
                  as: 'text'
                }
              }
            )
          }
        }
      }
    )
  }
}
function renderSelectMessageRuleGroupsField(h, { path, serviceName }) {
  if (this.checkPermissions(`advanced.${services.messageRuleGroups}.get`, permissionPresets.resellerUp)) {
    return h(
      components.select,
      {
        props: {
          value: this.proxy.messageRuleGroups,
          label: this.getTranslate(`${serviceName}.labels.${path}.${services.messageRuleGroups}`),
          service: services.messageRuleGroups,
          multiple: true,
          autocomplete: true,
          query: { isActive: true },
          labelMode: labelModes.outline,
          dense: true,
          clearable: true,
          details: false
        },
        on: {
          input: event => {
            this.proxy.messageRuleGroups = event
          }
        },
        scopedSlots: {
          selection: ({ item, removeByValue }) => {
            return h(
              tag,
              {
                props: {
                  label: item.title,
                  as: 'select-dense',
                  cancelable: true,
                  cancel: () => {
                    return removeByValue(item)
                  }
                }
              }
            )
          }
        }
      }
    )
  }
}
function renderSelectSenderNamesField(h, { path, serviceName }) {
  if (this.checkPermissions(`advanced.${services.sendernames}.get`, permissionPresets.resellerUp)) {
    return h(
      components.select,
      {
        props: {
          value: this.proxy.sendernames,
          label: this.getTranslate(`${serviceName}.labels.${path}.${services.sendernames}`),
          service: services.sendernames,
          picks: [ 'id', 'name', 'type' ],
          itemTitle: 'name',
          labelMode: labelModes.outline,
          dense: true,
          multiple: true,
          autocomplete: true,
          clearable: true,
          details: false
        },
        on: {
          input: event => {
            this.proxy.sendernames = event
          }
        },
        scopedSlots: {
          selection: ({ item, removeByValue }) => {
            return h(
              RowWithMessageTypeIcon,
              {
                props: {
                  value: item.type,
                  title: item.name,
                  cancelable: true,
                  cancel: () => {
                    return removeByValue(item)
                  }
                }
              }
            )
          },
          item: ({ item }) => {
            return h(
              RowWithMessageTypeIcon,
              {
                props: {
                  value: item.type,
                  title: item.name,
                  as: 'text'
                }
              }
            )
          }
        }
      }
    )
  }
}
function renderSelectPatternsField(h, { path, serviceName }) {
  if (this.checkPermissions(`advanced.${services.patterns}.get`, permissionPresets.resellerUp)) {
    return h(
      components.select,
      {
        props: {
          value: this.proxy.patterns,
          label: this.getTranslate(`${serviceName}.labels.${path}.${services.patterns}`),
          service: services.patterns,
          picks: [ 'id', 'title', 'type' ],
          labelMode: labelModes.outline,
          dense: true,
          multiple: true,
          autocomplete: true,
          clearable: true,
          details: false
        },
        on: {
          input: event => {
            this.proxy.patterns = event
          }
        },
        scopedSlots: {
          selection: ({ item, removeByValue }) => {
            return h(
              RowWithMessageTypeIcon,
              {
                props: {
                  value: item.type,
                  title: item.title,
                  cancelable: true,
                  cancel: () => {
                    return removeByValue(item)
                  }
                }
              }
            )
          },
          item: ({ item }) => {
            return h(
              RowWithMessageTypeIcon,
              {
                props: {
                  value: item.type,
                  title: item.title,
                  as: 'text'
                }
              }
            )
          }
        }
      }
    )
  }
}
function renderBody(h, options) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8 pt-2 px-2'
    },
    [
      renderAllowDuplicatesField.call(this, h, options),
      renderSenderNamesCheckField.call(this, h, options),
      renderPatternsCheckField.call(this, h, options),
      renderBalanceField.call(this, h, options),
      renderCurrencyField.call(this, h, options),
      renderSelectTariffsField.call(this, h, options),
      renderSelectRoutingGroupsField.call(this, h, options),
      renderSelectMessageRuleGroupsField.call(this, h, options),
      renderSelectSenderNamesField.call(this, h, options),
      renderSelectPatternsField.call(this, h, options)
    ]
  )
}

function renderSaveButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.save'),
        icon: icons.save,
        color: Colors.primary,
        mode: buttonModes.flat,
        loading: this.loading,
        disabled: this.disabled
      },
      on: {
        click: () => {
          this.submit()
        }
      }
    }
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer'
    },
    [ renderSaveButton.call(this, h) ]
  )
}

function renderContent(h, options) {
  return h(
    'div',
    {
      class: 'grid grid-gap--0'
    },
    [
      renderBody.call(this, h, options),
      renderFooter.call(this, h)
    ]
  )
}

export default function(h, options) {
  return h(
    components['expansion-panel'],
    {
      props: {
        outline: true,
        rounded: true
      },
      scopedSlots: {
        header: ({ expanded }) => {
          return renderHeader.call(this, h, options, expanded)
        },
        default: () => {
          return renderContent.call(this, h, options)
        }
      }
    }
  )
}
